/* eslint-disable react/jsx-no-literals */
/* eslint-disable formatjs/no-literal-string-in-jsx */
/* eslint-disable arrow-body-style */
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { baseStyles, tableStyles } from './styles';

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  summaryBox: {
    borderRadius: '8px',
    padding: '16px',
    marginTop: '16px',
    marginBottom: '24px',
  },
  scoreText: {
    fontSize: '20px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
  },
};

const srsMessages = {
  'Therapist Relationship': {
    title: <FormattedMessage defaultMessage="Relationship" />,
    description: (
      <FormattedMessage defaultMessage="How well did you feel heard, understood and respected by your care provider?" />
    ),
  },
  'Goals and Topics': {
    title: <FormattedMessage defaultMessage="Goals and Topics" />,
    description: (
      <FormattedMessage defaultMessage="How well did they feel that you worked on what they wanted to talk about?" />
    ),
  },
  'Approach or Method': {
    title: <FormattedMessage defaultMessage="Approach / Method" />,
    description: (
      <FormattedMessage defaultMessage="How well did your method and approach fit their needs?" />
    ),
  },
  Overall: {
    title: <FormattedMessage defaultMessage="Overall" />,
    description: (
      <FormattedMessage defaultMessage="How did they rate their overall experience?" />
    ),
  },
};

const scoreColor = score => {
  if (score <= 32) {
    return { text: '#8B091A', background: '#F2E6E8' }; // Low
  }
  if (score <= 36) {
    return { text: '#4D3D00', background: '#F7F2DA' }; // Medium
  }
  return { text: '#0A522E', background: '#E0F1E9' }; // High or fallback
};

const SRSAssessmentReport = props => {
  const { intl, srs, hasPreviousAppointment } = props;
  const totalScore = srs.reduce((acc, item) => acc + (item.score || 0), 0);
  const maxScore = srs.length * 10; // Assuming max 10 per item

  let summaryMessage;
  if (totalScore <= 34) {
    summaryMessage = intl.formatMessage({
      defaultMessage: 'Suggets a poor alliance',
    });
  } else if (totalScore <= 38) {
    summaryMessage = intl.formatMessage({
      defaultMessage: 'Suggests a fair alliance',
    });
  } else {
    summaryMessage = intl.formatMessage({
      defaultMessage: 'Suggests a good alliance',
    });
  }

  return (
    <div style={baseStyles.card}>
      {hasPreviousAppointment && (
        <div>
          <div style={baseStyles.sectionTitle}>
            {intl.formatMessage({ defaultMessage: 'Summary' })}
          </div>
          <div
            style={{
              ...styles.summaryBox,
              background: scoreColor(totalScore).background,
            }}
          >
            <div
              style={{
                ...styles.scoreText,
                fontWeight: 400,
                color: scoreColor(totalScore).text,
              }}
            >
              {intl.formatMessage({ defaultMessage: 'Total Score' })}
            </div>
            <div
              style={{
                ...styles.scoreText,
                color: scoreColor(totalScore).text,
              }}
            >
              {totalScore}/{maxScore} &nbsp;|&nbsp; {summaryMessage}
            </div>
          </div>
        </div>
      )}
      <div style={baseStyles.sectionTitle}>
        {intl.formatMessage({ defaultMessage: 'Breakdown' })}
      </div>
      <table style={tableStyles.table}>
        <thead>
          <tr>
            <th style={tableStyles.th}>
              {intl.formatMessage({ defaultMessage: 'Area(s)' })}
            </th>
            <th style={tableStyles.th}>
              {intl.formatMessage({ defaultMessage: 'Client Rating' })}
              <br />({intl.formatMessage({ defaultMessage: 'Last Session' })})
            </th>
          </tr>
        </thead>
        <tbody>
          {srs.map((q, idx) => {
            const message = srsMessages[q.name] || {
              title: q.name,
              description: '',
            };

            return (
              <tr key={q.name}>
                <td style={tableStyles.td}>
                  <div style={{ fontWeight: 600 }}>
                    {`${idx + 1}. `}
                    {message.title}
                  </div>
                  <div style={styles.subtitle}>{message.description}</div>
                </td>
                <td style={tableStyles.td}>
                  <strong>{q.score === null ? '-' : `${q.score}/10`}</strong>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

SRSAssessmentReport.propTypes = {
  intl: PropTypes.object.isRequired,
  srs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      score: PropTypes.string.isRequired,
    }),
  ).isRequired,
  hasPreviousAppointment: PropTypes.bool.isRequired,
};

export default injectIntl(SRSAssessmentReport);
